import { readableTextOn } from './colorAttributes'

export const DEFAULT_BUTTON_COLOR = '#045db5'

// Inline styles of the "Price and enrolment" block, shared by renderHTML (saved HTML)
// and the editor node view so both look the same. The public page has no `prose` nor
// CSS variables, hence everything inline.
export const PRICE_ENROLL_STYLES = {
  wrapper: 'margin:16px 0;',
  // break-word: a word only breaks when it alone doesn't fit (the aside can be ~200px wide).
  heading: 'text-align:center;margin:0;max-width:100%;overflow-wrap:break-word;',
  buttonRow: 'display:flex;justify-content:center;margin-top:8px;',
  // #4b5563 on white is ~7.5:1
  note: 'text-align:center;margin:8px 0 0;font-size:14px;color:#4b5563;',
}

// The price is free text ("50 €", "Bonificado 100€/mes"...): the longer it is, the smaller the font,
// so it fits the aside without breaking words. Length counted after trimming and collapsing spaces.
export const PRICE_SHORT_MAX_LENGTH = 7
export const PRICE_MEDIUM_MAX_LENGTH = 14
export const PRICE_FONT_SIZE_SHORT = 48
export const PRICE_FONT_SIZE_MEDIUM = 26
export const PRICE_FONT_SIZE_LONG = 20

export function priceEnrollPriceStyle(price) {
  const length = [...String(price || '').trim().replace(/\s+/g, ' ')].length
  const size = length <= PRICE_SHORT_MAX_LENGTH ? PRICE_FONT_SIZE_SHORT
    : length <= PRICE_MEDIUM_MAX_LENGTH ? PRICE_FONT_SIZE_MEDIUM
      : PRICE_FONT_SIZE_LONG
  return `font-size:${size}px;`
}

// `color` must already be a validated #rrggbb.
export function priceEnrollButtonStyle(color) {
  return `display:block;width:100%;max-width:700px;text-align:center;background-color:${color};`
    + `color:${readableTextOn(color)};font-weight:bold;font-size:17px;padding:14px 20px;`
    + 'border-radius:10px;text-decoration:none;'
}
